import React from 'react';
import PropTypes from 'prop-types';
import styles from './sort-icon.scss';

const SortIcon = ({ active, label, direction, onClick, labelClass, activeSortAttr, sortAttr }) => {
  const sortContainerClass = [styles['sort-container'], 'sort-icon'];
  const upArrowClass = [styles.arrow, styles.up];
  const downArrowClass = [styles.arrow, styles.down];

  if (active) {
    sortContainerClass.push(styles['active-sort']);

    if (activeSortAttr === sortAttr && direction === 'descending') {
      upArrowClass.push(styles.active);
    } else if (activeSortAttr === sortAttr && direction === 'ascending') {
      downArrowClass.push(styles.active);
    } else {
      upArrowClass.push(styles.active);
      downArrowClass.push(styles.active);
    }
  }

  return (
    <React.Fragment>
      <span className={`${styles.label} ${labelClass}`} onClick={onClick}>
        {label}
      </span>
      <span className={sortContainerClass.join(' ')} onClick={onClick}>
        <span className={upArrowClass.join(' ')} />
        <span className={downArrowClass.join(' ')} />
      </span>
    </React.Fragment>
  );
};

SortIcon.propTypes = {
  active: PropTypes.bool,
  asc: PropTypes.bool,
  direction: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string,
  labelClass: PropTypes.string,
  activeSortAttr: PropTypes.string,
  sortAttr: PropTypes.string,
};

SortIcon.defaultProps = {
  active: true,
  asc: true,
  labelClass: '',
};

export default SortIcon;
